
import { addLayerExist, removerLayerExist } from '../layerStatusControl'

var tiles3dInfo = {}
const default3DTilesStyle = {
  pointSize: 5.0,
  color: "color('#ff0000')"
}
// 添加 3Dtiles 图层
function add3DTilesLayer (params, viewer) {
  // id 必须值
  // todo 是否进行 重复性设置
  const id = params.id || ''
  const _url = params.url || ''
  const tileset = new Cesium.Cesium3DTileset({
    url: _url
    //  clippingPlanes: clippingPlanes
  })
  const style = params.style
  if (style) {
    tileset.style = new Cesium.Cesium3DTileStyle(style)
  }
  tiles3dInfo[id] = tileset
  viewer.scene.primitives.add(tileset)
  viewer.zoomTo(tileset, new Cesium.HeadingPitchRange(0.0, -1.0, 50.0))
  const addInfo = {
    info: params,
    layer: null,
    market: tileset
  }
  addLayerExist(addInfo)
  return true
}

// 移除 3Dtiles 图层
function remove3DTilesLayer (params, viewer) {
  // id 必须值
  const id = params.id
  if (tiles3dInfo[id]) {
    const tileset = tiles3dInfo[id]
    viewer.scene.primitives.remove(tileset)
    tiles3dInfo[id] = null
    removerLayerExist(params)
    return true
  }
  return false
}

// 设置 3Dtiles 图层样式
function set3DTilesLayerStyles (params, style) {
  // 设置对应的 3DTiles的样式
  style = style || default3DTilesStyle
  const id = params.id
  if (tiles3dInfo[id]) {
    const tileset = tiles3dInfo[id]
    tileset.style = new Cesium.Cesium3DTileStyle(style)
    return true
  }
  return false
}

export { add3DTilesLayer, remove3DTilesLayer, set3DTilesLayerStyles }
